import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import FileNameValidationSchema from '../FileNameValidationSchema';
import { Validation } from '../Validation';

const { subscriberManagementCompanyContract } =
  loanFormModel.formField.solarSystemDocuments;

export class SubscriberManagementCompanyContractValidation
  implements ValidationSchema
{
  public name = subscriberManagementCompanyContract.name;
  public label = '';
  public dependsOn: string[] = [];
  public type = 'array';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(schema) {
    return FileNameValidationSchema(
      subscriberManagementCompanyContract.name,
      false
    );
  }
}
export default new Validation(
  new SubscriberManagementCompanyContractValidation()
);
